import React from 'react'
import { SortableContainer } from 'react-sortable-hoc'
import { Row } from 'antd'

import Item from './Item'

function Comp (
    {
        form,

        action,
        contents = [],

        onChange,
    }
)
{
    return (
        <Row type="flex" >
            {
                contents.map((content, i) =>
                {
                    return (
                        <Item
                            key={content.id || `link-${i}`}
                            form={form}
                            index={i}
                            sortIndex={i}
                            length={contents.length}
                            onChange={onChange}
                            action={action}
                            value={content}
                        />
                    )
                })
                .filter (e => !!e)
            }
        </Row>
    )
}

export default SortableContainer(Comp)